import { statusMeta } from "@/lib/format";

export function StatusBadge({ status, testid }) {
    const m = statusMeta(status);
    return (
        <span
            data-testid={testid || `status-${status}`}
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${m.cls}`}
        >
            {m.label}
        </span>
    );
}
